/* NgRx */
import {createAction, props} from '@ngrx/store';
import {MetricOptionModel} from '../../../../models/metric-option.model';
import {FetchMetricValuesModel} from '../models/fetch-metric-values.model';
import {FetchMetricsOptionsModel} from '../models/fetch-metrics-options.model';
import {EditMetricValueModel} from '../models/edit-metric-value.model';
import {DeleteMetricValueModel} from '../models/delete-metric-value.model';
import {AddMetricValueModel} from '../models/add-metric-value.model';
import {DeleteMetricValueListModel} from '../models/delete-metric-value-list.model';
import {EditMetricValueListModel} from '../models/edit-metric-value-list.model';


/******** CLEAR STATE ***********/
const CLEAR_STATE = '[metrics] clear state';
export const ClearState = createAction(CLEAR_STATE);

/******** FETCH METRICS OPTIONS ***********/
const FETCH_METRICS_OPTIONS_REQUEST = '[metrics] fetch metrics options requested';
export const FetchMetricsOptionsRequest = createAction(FETCH_METRICS_OPTIONS_REQUEST, props<{
  payload?: FetchMetricsOptionsModel['request']
}>());

const FETCH_METRICS_OPTIONS_SUCCESS = '[metrics] fetch metrics options successful';
export const FetchMetricsOptionsSuccess = createAction(FETCH_METRICS_OPTIONS_SUCCESS, props<{
  metricsOptions: MetricOptionModel[]
  message: string
}>());

const FETCH_METRICS_OPTIONS_FAILURE = '[metrics] fetch metrics options failure';
export const FetchMetricsOptionsFailure = createAction(FETCH_METRICS_OPTIONS_FAILURE);

/******** FETCH METRICS DATA ***********/
const FETCH_METRICS_DATA_REQUEST = '[metrics] fetch metrics requested';
export const FetchMetricsDataRequest = createAction(FETCH_METRICS_DATA_REQUEST, props<{
  payload: FetchMetricValuesModel['unprocessedRequest']
}>());

const FETCH_METRICS_DATA_SUCCESS = '[metrics] fetch metrics successful';
export const FetchMetricsDataSuccess = createAction(FETCH_METRICS_DATA_SUCCESS, props<any>());

const FETCH_METRICS_DATA_FAILURE = '[metrics] fetch metrics failure';
export const FetchMetricsDataFailure = createAction(FETCH_METRICS_DATA_FAILURE, props<{ payload: { code: string } }>());

/******** ADD METRIC VALUE ***********/
const ADD_METRIC_VALUE_REQUEST = '[metrics] add metric value requested';
export const AddMetricValueRequest = createAction(ADD_METRIC_VALUE_REQUEST, props<{
  payload: AddMetricValueModel['request']
}>());

const ADD_METRIC_VALUE_SUCCESS = '[metrics] add metric value successful';
export const AddMetricValueSuccess = createAction(ADD_METRIC_VALUE_SUCCESS, props<{ message: string }>());

const ADD_METRIC_VALUE_FAILURE = '[metrics] add metric value failure';
export const AddMetricValueFailure = createAction(ADD_METRIC_VALUE_FAILURE);

/******** EDIT METRIC VALUE ***********/
const EDIT_METRIC_VALUE_REQUEST = '[metrics] edit metric value requested';
export const EditMetricValueRequest = createAction(EDIT_METRIC_VALUE_REQUEST, props<{
  payload: EditMetricValueModel['unprocessedRequest']
}>());

const EDIT_METRIC_VALUE_SUCCESS = '[metrics] edit metric value successful';
export const EditMetricValueSuccess = createAction(EDIT_METRIC_VALUE_SUCCESS, props<{ message: string }>());

const EDIT_METRIC_VALUE_FAILURE = '[metrics] edit metric value failure';
export const EditMetricValueFailure = createAction(EDIT_METRIC_VALUE_FAILURE);

/******** DELETE METRIC VALUE ***********/
const DELETE_METRIC_VALUE_REQUEST = '[metrics] delete metric value requested';
export const DeleteMetricValueRequest = createAction(DELETE_METRIC_VALUE_REQUEST, props<{
  payload: DeleteMetricValueModel['unprocessedRequest']
}>());

const DELETE_METRIC_VALUE_SUCCESS = '[metrics] delete metric value successful';
export const DeleteMetricValueSuccess = createAction(DELETE_METRIC_VALUE_SUCCESS, props<{ message: string }>());

const DELETE_METRIC_VALUE_FAILURE = '[metrics] delete metric value failure';
export const DeleteMetricValueFailure = createAction(DELETE_METRIC_VALUE_FAILURE);

/******** DELETE METRIC VALUE LIST ***********/
const DELETE_METRIC_VALUE_LIST_REQUEST = '[metrics] delete metric value list requested';
export const DeleteMetricValueListRequest = createAction(DELETE_METRIC_VALUE_LIST_REQUEST, props<{
  payload: DeleteMetricValueListModel['unprocessedRequest']
}>());

const DELETE_METRIC_VALUE_LIST_SUCCESS = '[metrics] delete metric value list successful';
export const DeleteMetricValueListSuccess = createAction(DELETE_METRIC_VALUE_LIST_SUCCESS, props<{ message: string }>());

const DELETE_METRIC_VALUE_LIST_FAILURE = '[metrics] delete metric value list failure';
export const DeleteMetricValueListFailure = createAction(DELETE_METRIC_VALUE_LIST_FAILURE);

/******** EDIT METRIC VALUE LIST ***********/
const EDIT_METRIC_VALUE_LIST_REQUEST = '[metrics] edit metric value list requested';
export const EditMetricValueListRequest = createAction(EDIT_METRIC_VALUE_LIST_REQUEST, props<{
  payload: EditMetricValueListModel['unprocessedRequest']
}>());

const EDIT_METRIC_VALUE_LIST_SUCCESS = '[metrics] edit metric value list successful';
export const EditMetricValueListSuccess = createAction(EDIT_METRIC_VALUE_LIST_SUCCESS, props<{ message: string }>());

const EDIT_METRIC_VALUE_LIST_FAILURE = '[metrics] edit metric value list failure';
export const EditMetricValueListFailure = createAction(EDIT_METRIC_VALUE_LIST_FAILURE);

/******** FETCH METRICS VALUE BY DATE ***********/
const CHECK_METRICS_VALUE_EXISTS_BY_DATE_REQUEST = '[metrics] fetch metrics value by date requested';
export const CheckMetricsValueExistsByDateRequest = createAction(CHECK_METRICS_VALUE_EXISTS_BY_DATE_REQUEST, props<{ payload: any }>());

const CHECK_METRICS_VALUE_EXISTS_BY_DATE_SUCCESS = '[metrics] fetch metrics value by date successful';
export const CheckMetricsValueExistsByDateSuccess = createAction(CHECK_METRICS_VALUE_EXISTS_BY_DATE_SUCCESS);

const CHECK_METRICS_VALUE_EXISTS_BY_DATE_FAILURE = '[metrics] fetch metrics value by date failure';
export const CheckMetricsValueExistsByDateFailure = createAction(CHECK_METRICS_VALUE_EXISTS_BY_DATE_FAILURE);
